
const { BASE_URL } = require("./client");

const GET_USER_DETAILS = BASE_URL + "/userdetails";
const POST_APPROVED = BASE_URL + '/courseupload/accept/';
const POST_REJECTED = BASE_URL + '/courseupload/reject/';
const POST_APPROVED_WORKEX = BASE_URL + '/courseupload/accept/workex/';
const POST_REJECTED_WORKEX = BASE_URL + '/courseupload/reject/workex/';
export { GET_USER_DETAILS , POST_APPROVED , POST_REJECTED , POST_APPROVED_WORKEX , POST_REJECTED_WORKEX};